import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { BackgroundProcessesTable } from './BackgroundProcessesTable';

export default function BackgroundProcessesTab() {
  return <CompanyWrapper contentComponent={BackgroundProcessesContent} />;
}

function BackgroundProcessesContent({ company }: { company: Company }) {
  return <BackgroundProcessesTable company={company} />;
}
